export function SkipLink() {
  return (
    <a
      href="#main-content"
      className="sr-only focus-visible:not-sr-only focus-visible:absolute focus-visible:top-4 focus-visible:left-4 focus-visible:z-50 focus-visible:px-4 focus-visible:py-2 focus-visible:bg-page-bg focus-visible:text-body focus-visible:text-sm focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-accent focus-visible:outline-none focus-visible:border focus-visible:border-border-divider focus-visible:shadow-sm"
    >
      Skip to content
    </a>
  )
}
